"use client";

import { useComparisonContext } from "@/context/ComparisonContext";
import { useRouter, useSearchParams } from "next/navigation";

export default function ComparisonStickyBar() {
  const { selectedIds, clearCompare, isComparisonPage } = useComparisonContext();
  const router = useRouter();
  const searchParams = useSearchParams();

  // If we are already on the comparison page, or no items selected, hide it.
  if (isComparisonPage || !selectedIds || selectedIds.length === 0) {
    return null;
  }

  const handleCompareClick = () => {
    if (selectedIds.length >= 2) {
      const current = new URLSearchParams(Array.from(searchParams.entries()));
      current.delete("compare");
      current.set("ids", selectedIds.join(","));
      router.push(`/comparison?${current.toString()}`);
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-2 py-4 md:p-4 pointer-events-none">
      <div className="max-w-md mx-auto bg-white border-t border-x border-gray-200 rounded-t-2xl shadow-[0_-8px_30px_rgb(0,0,0,0.12)] p-4 flex items-center justify-between pointer-events-auto">
        <div className="flex flex-col">
          <span className="font-semibold text-gray-900">
            {selectedIds.length} {selectedIds.length === 1 ? "tour" : "tours"} selected
          </span>
          {selectedIds.length === 1 && (
            <span className="text-sm text-gray-500">Select one more tour</span>
          )}
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={clearCompare}
            className="text-gray-400 hover:text-gray-600 cursor-pointer btn-text font-medium"
          >
            Clear
          </button>
          <button
            onClick={handleCompareClick}
            disabled={selectedIds.length < 2}
            className={`px-2 md:px-4 py-2 rounded-lg font-medium btn-text transition-colors whitespace-nowrap ${
              selectedIds.length >= 2
                ? "bg-primary text-white hover:bg-primary/90 cursor-pointer shadow-sm"
                : "bg-gray-100 text-gray-400 cursor-not-allowed"
            }`}
          >
            Compare Tours
          </button>
        </div>
      </div>
    </div>
  );
}
